import screenbanner from "./image/background/1.jpg";
import mobilebanner from "./image/background/2.jpg"
import east from "./image/Location/e.png"
import north from "./image/Location/n.png"
import south from "./image/Location/s.png"


export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};
export const LocationData = {
  taglineheading: "Hot Localities in Mumbai",
  locationtag: "",
  location: [
    {
      title: "North Mumbai",
      propertcount: 1,
      image: north,
      link: `/location/mumbai/north`,
    },
    {
      title: "South Mumbai",
      propertcount: 4,
      image: south,
      link: `/location/mumbai/south`,
    },
    
    {
      title: "East Mumbai",
      propertcount: 1,
      image: east,
      link: `/location/mumbai/east`,
    },
   
    
  ],
};
